// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "fa04541df94f9a59280a" + "/js/" + chunkId + ".js";
};